import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs";
import { ZipEntry } from "app/modules/shared/model/zip-entry.interface";
import { ZipTask } from "app/modules/shared/model/zip-task.interface";
import { ZipTaskProgress } from "app/modules/shared/model/zip-task-progress.interface";

declare const zip: any;

@Injectable()
export class ZipService {
  constructor() {
    zip.workerScriptsPath = "scripts/";
  }

  getEntries(file): Observable<Array<ZipEntry>> {
    return new Observable((subscriber) => {
      const reader = new zip.BlobReader(file);
      zip.createReader(
        reader,
        (zipReader) => {
          zipReader.getEntries((entries) => {
            subscriber.next(entries);
            subscriber.complete();
          });
        },
        (message) => {
          subscriber.error({ message });
        }
      );
    });
  }

  getData(entry: ZipEntry): ZipTask {
    const progress = new Subject<ZipTaskProgress>();
    const data = new Observable<Blob>((subscriber) => {
      const writer = new zip.BlobWriter();
      (entry as any).getData(
        writer,
        (blob) => {
          subscriber.next(blob);
          subscriber.complete();
          progress.next(null);
        },
        (current, total) => {
          progress.next({ active: true, current, total });
        }
      );
    });
    return { progress, data };
  }
}
